var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorAssets01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#90d12a;}.cls-3{isolation:isolate;}.cls-4{fill:#b8ea60;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    className: "cls-1",
    cx: 176.1,
    cy: 180.6,
    r: 146
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "cls-2",
    d: "M311.2,147a138.2,138.2,0,0,0-42.4-70.2l-3.4,30.3c-1.5,12.8-6.6,19.3-14.9,21.3a22.8,22.8,0,0,1-11.6.3l-3.3-13.3a19.8,19.8,0,0,0,10.5.8c2.8-.7,4.3-2.6,5-5.9l.7-5.1L217.5,63l17.9-4.5,19.5,26.1,1.6-17.7a138.9,138.9,0,0,0-23.4-13.4l-1.2.4a24,24,0,0,1-11.6.2L218.8,48a148.6,148.6,0,0,0-28-6l.6,2.3-16,4-1.7-7c-2.4,0-4.8.1-7.1.3l1.4,5.8c-2.8,3.2-8.1,5.8-12.5,6.9-9.4,2.3-15-.5-18.3-7.6-4.2,1.3-8.3,2.6-12.3,4.2l2.3,9.4-15.8,3.9-1.5-6.3A127.8,127.8,0,0,0,93.8,68v.6l-1.4.3A138.2,138.2,0,0,0,76.7,82.7l2.5,10.2L64.7,96.5a148.3,148.3,0,0,0-11.1,17.2l.2.7,19.4-4.8,2.9,11.5-19.5,4.8,3.8,15.3,29.4-7.3,3.5,14L47.7,159.3l-5-20.1A140,140,0,0,0,77.8,279.9l-8.3-33.2,45.2-11.3,3.5,14-29,7.3,3.6,14.2,19.4-4.8,2.9,11.5-19.5,4.9,3.7,14.8.6.3,28.9-7.2,3.5,14.1-13.6,3.4c2.8,1.3,5.8,2.5,8.7,3.6l5.9-1.5,1,3.8a136.6,136.6,0,0,0,34.1,6.2,27.4,27.4,0,0,1,4-1.5c4.9-1.2,9.6-1.1,13.6,1.3,3.3-.2,6.6-.6,10-1.1l-1.2-4.6c9.9-2.4,13.8-4.5,10.6-19.4l9.4-2.3,4,15.7,13.9-3.4.8,3,5.9-2.8-.5-1.8,6.8-1.7a136.8,136.8,0,0,0,30.4-23.7l-1.5-5.8a19.4,19.4,0,0,0,5.7,1.2,146.8,146.8,0,0,0,9.8-12.3l-33.6-41.3,17.9-4.4,19.5,26,2.9-31.6,14.2-3.6-1.8,15.8A138.4,138.4,0,0,0,311.2,147ZM184.8,291.4l-15.7,3.9-6.7-26.8c-2.4-9.4-6.6-11.6-11.8-10.3s-8.1,5.3-5.7,14.7l6.6,26.8-16,4-12.6-50.9,16-4,2,8.2c.5-3.7,3.8-10.8,12.9-13.1s19.4.6,23.9,19Zm-39-156.6-15.8,4L123.3,112c-2.3-9.4-6.5-11.7-11.7-10.4s-8.1,5.4-5.8,14.8l6.7,26.7-16,4L83.9,96.3l15.9-4,2.1,8.2c.5-3.7,3.8-10.8,12.8-13.1s19.4.6,24,18.9Zm70.9,105.7L202.8,244l5.5,22c.9,3.6,2.7,5.8,6.3,4.9s6.4-4.9,7.5-6.8l3.6,14.4c-2.9,3.2-8.2,5.8-12.6,6.9-11.5,2.9-17.4-2.1-20.1-13l-6.1-24.5-8.1,2-2.6-10.4c9.9-2.4,13.8-4.5,10.6-19.4l9.4-2.3,4,15.8,13.9-3.5ZM177.7,84l-14,3.4,5.5,22c.9,3.7,2.8,5.8,6.3,4.9s6.5-4.8,7.6-6.7l3.5,14.4c-2.8,3.2-8.1,5.8-12.5,6.9-11.5,2.8-17.4-2.2-20.2-13.1l-6.1-24.4-8,2L137.2,83c9.9-2.5,13.8-4.5,10.5-19.4l9.5-2.4,4,15.8,13.9-3.4Zm79.9,150.4a25.6,25.6,0,0,0-7.8.3c-7.6,1.9-8.8,8.4-6.7,17l5.9,23.7-16,4-12.7-50.9,16-4,2.4,9.5c.8-8,5.2-12.5,15.2-15Zm-39-156.5a25.4,25.4,0,0,0-7.8.3c-7.7,1.9-8.9,8.4-6.7,17l5.9,23.6-16,4L181.3,72l16-4,2.4,9.5c.8-8,5.2-12.6,15.2-15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.6,169.6l44.3-11,3.5,13.7-28.5,7.1,3.5,14,19.1-4.7L95.3,200l-19.1,4.7,3.7,15,28.8-7.2,3.4,13.8L67.5,237.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.3,216.3,145.7,190c-2.2-9.2-6.4-11.4-11.5-10.1s-7.9,5.2-5.6,14.4l6.5,26.3-15.7,3.9L107,174.7l15.7-4,2,8c.5-3.6,3.7-10.6,12.6-12.8s19,.6,23.5,18.6l7,27.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.8,187.5c.9,3.6,2.7,5.7,6.2,4.8s6.4-4.8,7.4-6.6l3.5,14.1c-2.8,3.1-8,5.7-12.3,6.8-11.3,2.8-17.1-2.1-19.7-12.8l-6-24-7.9,2-2.5-10.2c9.6-2.4,13.5-4.5,10.3-19l9.3-2.4,3.8,15.5,13.7-3.4,2.5,10.2-13.6,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.8,150.8l15.7-3.9,2.3,9.2c.8-7.8,5.1-12.3,14.9-14.7l3.6,15.1a24.3,24.3,0,0,0-7.6.3c-7.5,1.9-8.7,8.2-6.6,16.7l5.8,23.2-15.7,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.3,142.4l17.6-4.4L276,163.6l2.9-31.1,13.9-3.4-6.5,56.5c-1.4,12.6-6.4,18.9-14.6,21a23,23,0,0,1-11.3.3l-3.3-13.1a19.1,19.1,0,0,0,10.3.8c2.8-.7,4.3-2.5,4.9-5.8l.7-5Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-4",
    d: "M79.2,92.9,64.7,96.5a142.9,142.9,0,0,1,12-13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "cls-4",
    d: "M115.1,277.6l-19.5,4.9,3.7,14.8a143.6,143.6,0,0,1-21.5-17.4l-8.3-33.2,45.2-11.3,3.5,14-29,7.3,3.6,14.2,19.4-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "cls-4",
    d: "M127.4,311.5l5.9-1.5,1,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    className: "cls-4",
    d: "M60.4,141.2l29.4-7.3,3.5,14L47.7,159.3l-5-20.1a142.8,142.8,0,0,1,10.9-25.5v.7l19.5-4.8,2.9,11.5-19.5,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    className: "cls-4",
    d: "M99.9,297.6l28.9-7.2,3.5,14.1-13.6,3.4A137.3,137.3,0,0,1,99.9,297.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    className: "cls-2",
    d: "M93.9,68.6l-1.4.3,1.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    className: "cls-4",
    d: "M172.4,318.5c4.9-1.2,9.6-1.1,13.6,1.3a147.7,147.7,0,0,1-17.6.2A27.4,27.4,0,0,1,172.4,318.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    className: "cls-4",
    d: "M109.9,57.9a113.8,113.8,0,0,1,15-7l2.3,9.4-15.8,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "cls-4",
    d: "M138.7,106.3l7.1,28.5-15.8,4L123.3,112c-2.3-9.4-6.5-11.7-11.7-10.4s-8.1,5.4-5.8,14.8l6.7,26.7-16,4L83.9,96.3l15.9-4,2.1,8.2c.5-3.7,3.8-10.8,12.8-13.1S134.1,88,138.7,106.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    className: "cls-4",
    d: "M177.7,262.9l7.1,28.5-15.7,3.9-6.7-26.8c-2.4-9.4-6.6-11.6-11.8-10.3s-8.1,5.3-5.7,14.7l6.6,26.8-16,4-12.6-50.9,16-3.9,2,8.1c.5-3.7,3.8-10.8,12.9-13S173.2,244.5,177.7,262.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    className: "cls-4",
    d: "M137.2,46.7l4.9-1.3a135.7,135.7,0,0,1,24.5-3.8l1.4,5.8c-2.8,3.2-8.1,5.8-12.5,6.9C146.1,56.6,140.5,53.7,137.2,46.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    className: "cls-4",
    d: "M161.2,77l13.9-3.4,2.6,10.3-14,3.5,5.5,22c.9,3.7,2.8,5.8,6.3,4.9s6.5-4.8,7.5-6.7l3.6,14.4c-2.9,3.2-8.1,5.8-12.5,6.9-11.5,2.8-17.4-2.2-20.2-13.1l-6.1-24.4-8,2L137.2,83c9.9-2.5,13.8-4.5,10.5-19.4l9.5-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    className: "cls-4",
    d: "M200.2,233.6l13.9-3.5,2.6,10.4L202.8,244l5.5,22c.9,3.6,2.7,5.8,6.3,4.9s6.4-4.9,7.5-6.8l3.6,14.4c-2.9,3.2-8.2,5.8-12.6,6.9-11.5,2.9-17.4-2.1-20.1-13l-6.1-24.5-8.1,2-2.6-10.4c9.9-2.4,13.8-4.5,10.6-19.4l9.4-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    className: "cls-4",
    d: "M218.8,308.1l13.9-3.4.8,3a135.3,135.3,0,0,1-23.9,8.3c-4.5,1.1-9.1,2-13.6,2.7l-1.2-4.6c9.9-2.4,13.8-4.5,10.6-19.4l9.4-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    className: "cls-4",
    d: "M238.9,303.1l6.8-1.7-6.3,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    className: "cls-4",
    d: "M191.4,44.3l-16,3.9-1.8-7a163.7,163.7,0,0,1,17.2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    className: "cls-4",
    d: "M253.9,219l3.7,15.4a25.6,25.6,0,0,0-7.8.3c-7.6,1.9-8.8,8.4-6.7,17l5.9,23.7-16,4-12.7-50.9,16-3.9,2.4,9.4C239.5,226,243.9,221.5,253.9,219Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    className: "cls-4",
    d: "M214.8,62.5l3.8,15.4a22.7,22.7,0,0,0-7.8.3c-7.7,1.9-8.9,8.4-6.7,17l5.9,23.6-16,4L181.3,72l16-4,2.4,9.5C200.5,69.5,204.9,64.9,214.8,62.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    className: "cls-4",
    d: "M274.6,271.9a19.4,19.4,0,0,0,5.7,1.2l-4.2,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    className: "cls-4",
    d: "M231.9,53.9a24,24,0,0,1-11.6.2L218.8,48A134.6,134.6,0,0,1,233,53.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    className: "cls-4",
    d: "M251.8,105.2,217.5,63l17.9-4.5,19.5,26.1,1.6-17.7a129.9,129.9,0,0,1,12.3,9.9l-3.4,30.3c-1.5,12.8-6.6,19.3-14.9,21.3a22.8,22.8,0,0,1-11.6.3l-3.3-13.3a19.8,19.8,0,0,0,10.5.8c2.8-.7,4.3-2.6,5-5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    className: "cls-4",
    d: "M311,205.9l-1.8,15.8A139.5,139.5,0,0,1,290,260.8l-33.5-41.3,17.9-4.4,19.5,26,2.9-31.6Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorAssets01);
export default __webpack_public_path__ + "static/media/Vector Assets-01.fd2d946c868098698619af5e3ce90f85.svg";
export { ForwardRef as ReactComponent };